import { render } from "./IconDestinationEmptyPlaceholderImage.vue?vue&type=template&id=01b9d528"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__